const settings = {
    timeFunction: (timeRatio) => timeRatio ** 2,
    progressFunction: (timeFunction, timeRatio) => (
        timeRatio < 0.5
            ? timeFunction(2 * timeRatio) / 2
            : (2 - timeFunction(2 * (1 - timeRatio))) / 2),
    duration: 500,
};

function scrollByProgress(progress, currentPosition, anchorPosition) {
    const dY = anchorPosition - currentPosition;
    const scrollPositionByProgress = currentPosition + progress * dY;
    window.scrollTo(0, scrollPositionByProgress);
}

function scrollAnimation(start, currentPosition, anchorPosition) {
    const { timeFunction, progressFunction, duration } = settings;

    function animate(time) {
        const timeRatio = (time - start) / duration > 1 ? 1 : (time - start) / duration;
        const progress = progressFunction(timeFunction, timeRatio);

        scrollByProgress(progress, currentPosition, anchorPosition);

        if (timeRatio < 1) {
            requestAnimationFrame(animate);
        }
    }
    requestAnimationFrame(animate);
}

function anchorScroll(ref = null) {
    if (ref) {
        const currentPosition = window.scrollY;
        const anchorPosition = ref.current.offsetTop;
        const start = performance.now();

        scrollAnimation(start, currentPosition, anchorPosition);
    }
}

export default anchorScroll;
